import { transform, type TransformedCartData } from "../transformers/CartResponseTransformer";
import { resolveApiUrl } from "../../../../utils/url/urlResolver";
import { registerCallProcessor, scheduleCall } from "~/features/cart/cart/api/CartService";
import { apiGET } from "~/app/api/apiCallsService";
import type { CartViewDTO } from "../dto/CartViewDTO";
import { buildEntryGroupsFromEntries } from "./preprocessCartEntries";

const apiUrl = resolveApiUrl("/cart/view");

export async function getData(): Promise<TransformedCartData> {
  const response = await scheduleCall("cartView", {});
  const oldDto: CartViewDTO = await response.json();
  const { dto, linearProducts } = preprocessData(oldDto);
  const cartData = transform(dto);
  if (linearProducts.length > 0) {
    cartData.products = [...cartData.products, ...linearProducts];
  }
  return cartData;
}

registerCallProcessor({
  type: "cartView",
  execute: async () => {
    return apiGET(apiUrl, {
      credentials: "same-origin", // include, omit
      mode: "cors", // no-cors, same-origin
      referrer: "no-referrer", // client
    });
  },
  canBeExecuted: (ongoingCalls) => {
    const isDeleteOngoing = ongoingCalls.some((call) => call.type === "delete" || call.type === "deleteCart");
    return !isDeleteOngoing;
  },
});

function preprocessData(dto: CartViewDTO) {
  const { entryGroups, packageEntries, products, linearProducts } = buildEntryGroupsFromEntries(
    dto.entries ?? [],
    "ORDERABLE",
    1,
    100,
  );

  return {
    dto: {
      code: dto.code,
      affiliateComment: dto.affiliateComment,
      dstError: dto.dstError,
      b2bCustomerData: dto.b2bCustomerData,
      packageEntries,
      entryGroups,
      products,
    },
    linearProducts,
  };
}
